import React from 'react'

import './esign-overview.style.scss'

const EsignOverview = () => {
  
  return (
    <div className="esign-overview">
      ePotpis je integracijsko rješenje za izradu kvalificiranog elektroničkog potpisa. Kvalificirani elektronički potpis, sukladno eIDAS uredbi Europskog parlamenta i Vijeća (EU 910/2014), ima jednak pravni učinak kao vlastoručni potpis. 
      Upotrebom ePotpis-a moguće je integrirati funkcionalnost izrade kvalificiranog elektroničkog potpisa iz gotovo bilo kojeg softverskog rješenja ili web aplikacije.
    </div>
  )
}

export default EsignOverview